import React from "react"

export default function FullWidthImageCarouselItem({ image, position }) {
  return (
    <div className={`full-width-image-carousel-item pos-${position ? position : "center"}`}>
      <img data-epi-property="BackgroundImage" src={image}></img>
    </div>
  )
}
